/**
 * Created by shiyonggao on 2019/1/22.
 */
module.exports = {
    'zh-CN': require('./lang/zh')
};



// WEBPACK FOOTER //
// ./website/language/lang_config.js